if (!customElements.get('collection-infinite-scroll')) {
  customElements.define('collection-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;
      this.grid = this.parentElement.querySelector('#product-grid');
      this.link = this.querySelector('[data-next-page]');
      this.status = this.querySelector('[role="status"]');
      if (!this.grid) return;
      this.querySelector('[data-pagination-fallback]').hidden = true;
      this.status.hidden = false;
      if (!this.link) {
        this.done = true;
        this.status.textContent = this.dataset.complete;
        return;
      }
      this.onRetry = (event) => {
        event.preventDefault();
        this.loadNext();
      };
      this.link.addEventListener('click', this.onRetry);
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '0px 0px 500px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.link?.removeEventListener('click', this.onRetry);
    }

    async loadNext() {
      if (this.loading || this.done || !this.isConnected || this.closest('.collection').classList.contains('loading')) return;
      this.loading = true;
      this.observer.unobserve(this);
      this.link.hidden = true;
      this.status.textContent = this.dataset.loading;
      this.controller = new AbortController();
      try {
        const url = new URL(this.link.href, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = html.querySelector('#product-grid');
        const items = nextGrid ? Array.from(nextGrid.children) : [];
        if (!items.length) throw new Error('Missing collection products');
        if (!this.isConnected || this.closest('.collection').classList.contains('loading')) return;
        // Match Dawn's filtered-grid behavior so appended cards are immediately visible.
        items.forEach((item) => {
          if (item.matches('.scroll-trigger')) item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'));
        });
        const next = html.querySelector('collection-infinite-scroll [data-next-page]');
        let nextUrl;
        if (next) {
          nextUrl = new URL(next.getAttribute('href'), location.origin);
          nextUrl.searchParams.delete('section_id');
          const currentPage = Number(url.searchParams.get('page') || 1);
          if (Number(nextUrl.searchParams.get('page') || 1) <= currentPage) throw new Error('Invalid next page');
        }
        this.grid.append(...items);
        this.status.textContent = '';
        if (nextUrl) {
          this.link.href = nextUrl.href;
          this.observer.observe(this);
        } else {
          this.done = true;
          this.status.textContent = this.dataset.complete;
        }
      } catch (error) {
        if (error.name !== 'AbortError' && this.isConnected) {
          this.status.textContent = this.dataset.error;
          this.link.hidden = false;
        }
      } finally {
        this.loading = false;
      }
    }
  });
}
